export const EAccAccountStatus = {
  "0": "UNKNOWN",
  "1": "ACTIVE",
  "2": "PASSIVE",
  "-1": "ALL"
};

export const EAccAccountType = {
  "0": "UNKNOWN",
  "1": "GSA",
  "2": "AGENCY",
  "3": "PROVIDER",
  "4": "VPOS",
  "5": "BANK",
  "6": "ACC",
  "7": "SAFE",
  "8": "HOTEL",
  "-1": "ALL"
};

export const EAccAccountSubType = {
  "0": "UNKNOWN",
  "1": "MAIN",
  "2": "INCOME",
  "3": "EXPENSE",
  "4": "GATE_GTS",
  "5": "GATE_GSA",
  "6": "LOAN",
  "-1": "ALL"
};

export const EAccTransactionType = {
  "0": "UNKNOWN",
  "1": "TRANSFER",
  "2": "VIRTUAL_CREDIT",
  "3": "PAYMENT",
  "4": "ENET_PAYMENT",
  "5": "NOSHOW_INCOME",
  "6": "PENALTY",
  "7": "PROVISION",
  "8": "SEGOP_FLIGHT",
  "9": "BONUS",
  "10": "CC_PAYMENT",
  "11": "CC_COMMISSION",
  "12": "KICKBACK_HOTEL",
  "13": "CASH_BACK",
  "20": "OTHER",
  "21": "F_TICKET",
  "22": "F_COM_GTS",
  "23": "F_COM_GSA",
  "24": "F_COM_AGENCY",
  "25": "F_COM_AGENCY_EXTRA",
  "26": "F_COM_PROVIDER",
  "27": "F_COM_PROVIDER_EXTRA",
  "28": "F_COM_VPOS",
  "29": "F_PAY_VPOS",
  "30": "F_ANCILLARY",
  "31": "F_TRX_FEE",
  "32": "F_TRX_FEE_REV",
  "33": "F_TICKET_DIFF",
  "34": "H_SALE",
  "35": "H_ADDON",
  "36": "H_COM_GTS",
  "37": "H_COM_GSA",
  "38": "H_COM_AGENCY",
  "39": "H_TRX_FEE",
  "40": "H_TRX_FEE_REV",
  "41": "H_PAY_VPOS",
  "42": "H_COM_VPOS",
  "43": "T_SALE",
  "44": "T_ANCILLARY",
  "45": "T_COM_GTS",
  "46": "T_COM_GSA",
  "47": "T_COM_AGENCY",
  "48": "T_TRX_FEE",
  "49": "T_TRX_FEE_REV",
  "50": "T_PAY_VPOS",
  "51": "T_COM_VPOS",
  "52": "H_COM_MARKETING",
  "53": "R_SALE",
  "54": "R_ANCILLARY",
  "55": "R_COM_GTS",
  "56": "R_COM_GSA",
  "57": "R_COM_AGENCY",
  "58": "R_TRX_FEE",
  "59": "R_TRX_FEE_REV",
  "60": "R_PAY_VPOS",
  "61": "R_COM_VPOS",
  "62": "R_SALE_EXTRA",
  "63": "H_KICKBACK",
  "110": "REV_CC_PAYMENT",
  "111": "REV_CC_COMMISSION",
  "121": "REV_F_TICKET",
  "122": "REV_F_COM_GTS",
  "123": "REV_F_COM_GSA",
  "124": "REV_F_COM_AGENCY",
  "125": "REV_F_COM_AGENCY_EXTRA",
  "126": "REV_F_COM_PROVIDER",
  "127": "REV_F_COM_PROVIDER_EXTRA",
  "128": "REV_F_COM_VPOS",
  "129": "REV_F_PAY_VPOS",
  "130": "REV_F_ANCILLARY",
  "131": "REV_F_TRX_FEE",
  "133": "REV_F_TICKET_DIFF",
  "134": "REV_H_SALE",
  "135": "REV_H_ADDON",
  "136": "REV_H_COM_GTS",
  "137": "REV_H_COM_GSA",
  "138": "REV_H_COM_AGENCY",
  "139": "REV_H_TRX_FEE",
  "141": "REV_H_PAY_VPOS",
  "142": "REV_H_COM_VPOS",
  "143": "REV_T_SALE",
  "144": "REV_T_ANCILLARY",
  "145": "REV_T_COM_GTS",
  "146": "REV_T_COM_GSA",
  "147": "REV_T_COM_AGENCY",
  "148": "REV_T_TRX_FEE",
  "150": "REV_T_PAY_VPOS",
  "151": "REV_T_COM_VPOS",
  "152": "REV_H_COM_MARKETING",
  "153": "REV_R_SALE",
  "154": "REV_R_ANCILLARY",
  "155": "REV_R_COM_GTS",
  "156": "REV_R_COM_GSA",
  "157": "REV_R_COM_AGENCY",
  "158": "REV_R_TRX_FEE",
  "160": "REV_R_PAY_VPOS",
  "161": "REV_R_COM_VPOS",
  "162": "REV_R_SALE_EXTRA",
  "163": "REV_H_KICKBACK",
  "201": "LOSS_SYS_FLIGHT",
  "202": "LOSS_STF_FLIGHT",
  "203": "LOSS_SYS_HOTEL",
  "204": "LOSS_STF_HOTEL",
  "205": "LOSS_SYS_TRANSFER",
  "206": "LOSS_STF_TRANSFER",
  "207": "LOSS_SYS_RENTACAR",
  "208": "LOSS_STF_RENTACAR",
  "-1": "ALL"
};

export const EAccTrxGroupBy = {
  "0": "UNKNOWN",
  "1": "TRX",
  "2": "SUB_ENTITY",
  "3": "ENTITY",
  "4": "ORDER",
  "-1": "ALL"
};

export const EAccDateType = {
  "0": "UNKNOWN",
  "1": "INSERT",
  "2": "EFFECTIVE",
  "-1": "ALL"
};

export const EAccReceiptType = {
  "0": "UNKNOWN",
  "1": "CC_PAYMENT",
  "2": "CC_DEPOSIT",
  "3": "SEPA_DEPOSIT",
  "-1": "ALL"
};